module.exports = __webpack_public_path__ + "static/media/focused-young-black-woman-holding-basket-with-lettuce-on-4177750 (1).3f8405f1.jpg";